import React from "react";
import moment from "moment";
import "./TtlSelector.scss";
import ButtonGroup from "../ButtonGroup/ButtonGroup";
import Button from "../Button/Button.js";
import TimeIcon from "./time.svg";
import DateSingle from "../DateRange/DateSingle.js";

const TtlSelector = ({ date, onChange }) => {
  const handleQuickChange = d => {
    onChange(d);
  };

  if (date) {
    return (
      <div className="ttl-selector">
        <DateSingle date={moment(date).toDate()} onChange={onChange} />
        <Button
          color="blue"
          className="date-clear"
          onClick={() => onChange(null)}
        >
          Убрать дату
        </Button>
      </div>
    );
  }
  return (
    <div className="ttl-selector">
      <ButtonGroup
        items={[
          { title: "3 дня ", code: moment().add(3, "days"), key: "3d" },
          { title: "1 неделя", code: moment().add(1, "weeks"), key: "1w" },
          { title: "Месяц", code: moment().add(1, "month"), key: "1m" }
        ]}
        onClick={handleQuickChange}
      />

      <DateSingle date={date} onChange={onChange}>
        <Button
          icon={TimeIcon}
          color="light-blue"
          className="time"
          className="date"
        />
      </DateSingle>
    </div>
  );
};

export default TtlSelector;
